import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/pricing');
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="#141517"
      color="white"
    >
      <Typography variant="h4" gutterBottom>
        Payment Cancelled
      </Typography>
      <Typography variant="body1" gutterBottom>
        Your payment was not completed. You can try again or contact support.
      </Typography>
      <Button variant="contained" color="secondary" onClick={handleGoBack}>
        Go Back to Pricing
      </Button>
    </Box>
  );
};

export default PaymentCancelPage;
